var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm",class:_vm.className,attrs:{"type":"button"},on:{"click":function($event){return _vm.confirm(_vm.doRequest)}}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])
}
var staticRenderFns = []

export { render, staticRenderFns }